// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Xnk6","head":"Table_head__1iiCG","col":"Table_col__1Dqu-"};